<template>
  <component
    :is="as"
    v-bind="$attrs"
    :class="[
      'q-mx-xs text-help-text',
      { 'text-blue-grey hover-ds-denim-8': as === 'BaseButton' },
    ]"
    :dense="as === 'BaseButton'"
    :flat="as === 'BaseButton'"
    @click.stop="$emit('click')"
  >
    <QIcon
      class="q-mr-xs engagement"
      :name="iconName"
      size="10px"
    />
    <span
      v-if="!hideEngagement"
      class="engagement"
    >
      {{ formattedValue }}
    </span>
    <slot />
  </component>
</template>

<script>
import { BaseButton } from "shared/components/base";
import { suffix } from "shared/helpers/number";

export default {
  name: "SocialMentionEngagementItem",
  components: {
    BaseButton,
  },
  props: {
    as: {
      type: String,
      default: "BaseButton",
    },
    hideEngagement: {
      type: Boolean,
    },
    icon: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
  },
  emits: ["click"],
  computed: {
    iconName() {
      return `img:https://assets.streem.com.au/icons/${this.icon}.svg`;
    },
    formattedValue() {
      return suffix(this.modelValue || 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.engagement {
  font-weight: bold;
  font-size: 10px;
  line-height: 10px;
}
</style>
